import { ActionButton } from "@/components/ActionButton";
import { cn } from "@/lib/utils";

/**
 * Липка кнопка дії внизу екрана — ОДНА на весь застосунок (owner 2026-08-29:
 * «в онбордингу кнопка одна, під вакансією зовсім інша, немає системи»).
 *
 * До цього кожен екран малював свою: різний радіус, різна висота, різний фон
 * під нею. Тепер вигляд заданий тут, а екрани лише передають текст і onClick.
 *
 * Ширина береться від Layout (px-5), тому власних горизонтальних відступів
 * додавати не треба — панель сама розтягується на всю ширину сторінки і
 * вирівнюється по краях карток.
 */

interface Props {
  label: string;
  /** Текст під час збереження. */
  pendingLabel?: string;
  pending?: boolean;
  disabled?: boolean;
  onClick: () => void;
  /** true — панель прибита до низу екрана (онбординг), інакше — до низу контенту. */
  fixed?: boolean;
}

export function StickyAction({
  label,
  pendingLabel = "Зберігаємо…",
  pending = false,
  disabled = false,
  onClick,
  fixed = false,
}: Props) {
  const off = disabled || pending;
  return (
    <div
      className={cn(
        "px-5 pb-6 pt-3",
        fixed
          ? "pointer-events-none fixed inset-x-0 bottom-0 z-20"
          : "sticky bottom-0 -mx-5 bg-paper",
      )}
      style={
        fixed
          ? {
              background:
                "linear-gradient(to bottom, rgba(245,241,232,0) 0%, rgba(245,241,232,0.92) 30%, rgba(245,241,232,1) 60%)",
            }
          : undefined
      }
    >
      <ActionButton disabled={off} onClick={onClick} className="pointer-events-auto">
        {pending ? pendingLabel : label}
      </ActionButton>
    </div>
  );
}
